import type { ConversionJob } from "../types/job";
import EmptyState from "./EmptyState";
import JobCard from "./JobCard";
import Skeleton from "./Skeleton";

interface JobListProps {
    jobs: ConversionJob[];
    loading: boolean;
    onDelete: (jobId: string) => void;
    deletingId: string | null;
}

export default function JobList({ jobs, loading, onDelete, deletingId }: JobListProps) {
    if (loading) return <Skeleton />;
    if (jobs.length === 0) return <EmptyState />;

    return (
        <ul className="space-y-3">
            {jobs.map((job) => (
                <JobCard
                    key={job.job_id}
                    job={job}
                    onDelete={onDelete}
                    deleting={deletingId === job.job_id}
                />
            ))}
        </ul>
    );
}
